import React, { useEffect, useState,useRef } from "react";
import { Box, Drawer, IconButton, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import CustomButton from "../../../../components/CustomButton";
import save from "../../../../assets/save.svg";

const AttendanceFilterDrawer = ({ open, onClose, filters, setFilters, onApplyFilters }) => {
  const { t } = useTranslation();
  const [localFilters, setLocalFilters] = useState(filters);
  
  // Status options according to API specification
  const statusOptions = [
    { key: "assigned", label: t("taskStatus.assigned") || "Assigned", value: "assigned" },
    { key: "accepted", label: t("taskStatus.accepted") || "Accepted", value: "accepted" },
    { key: "declined", label: t("taskStatus.declined") || "Declined", value: "declined" },
    { key: "inprogress", label: t("taskStatus.inprogress") || "In Progress", value: "in_progress" },
    { key: "completed", label: t("taskStatus.completed") || "Completed", value: "completed" },
    { key: "notdone", label: t("taskStatus.notdone") || "Not Done", value: "not_done" },
  ];

  useEffect(() => {
    if (open) setLocalFilters(filters);
  }, [open, filters]);

  // Handle multiple status selection
  const toggleStatus = (statusValue) => {
    setLocalFilters((prev) => {
      const currentStatuses = prev.status ? prev.status.split(",") : [];
      const isSelected = currentStatuses.includes(statusValue);
      
      let newStatuses;
      if (isSelected) {
        // Remove status
        newStatuses = currentStatuses.filter((s) => s !== statusValue);
      } else {
        // Add status
        newStatuses = [...currentStatuses, statusValue];
      }
      
      return {
        ...prev,
        status: newStatuses.length > 0 ? newStatuses.join(",") : "",
      };
    });
  };

  const isStatusSelected = (statusValue) => {
    if (!localFilters.status) return false;
    return localFilters.status.split(",").includes(statusValue);
  };

  const apply = () => {
    console.log("🔹 Filter selected in drawer (before API):", localFilters);
    onApplyFilters(localFilters);
    onClose();
  };

  const clear = () => {
    const cleared = { status: "", startDate: "", endDate: "", group_by_date: false };
    setLocalFilters(cleared);
    onApplyFilters(cleared);
    onClose();
  };

    const startRef = useRef(null);
  const endRef = useRef(null);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: "100%", sm: 400, md: 550 }, backgroundColor: "#E7EBEE" } }}
    >
      <Box sx={{ position: "sticky", top: 0, backgroundColor: "#E7EBEE", zIndex: 10, px: 2, py: 1.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 600, color: "#2C384C" }}>
            {t("filterDrawer.filterTask") || "Filter Tasks"}
          </CustomText>
        </Box>
      </Box>

      <Box sx={{ px: 2 }}>
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            px: 3,
            py: 3,
            height: "calc(100vh - 90px)",
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {/* Status Filter - Multiple Selection */}
          {/* <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 500, color: "#2C384C", textAlign: "left", pt: 3 }}>
            {t("filterDrawer.status") || "Status"} {t("filterDrawer.selectMultiple") || "(Select Multiple)"}
          </CustomText> */}
          {/* <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
            {statusOptions.map((opt) => {
              const isSelected = isStatusSelected(opt.value);
              return (
                <Button
                  key={opt.key}
                  variant="outlined"
                  size="small"
                  onClick={() => toggleStatus(opt.value)}
                  sx={{
                    borderRadius: "6px",
                    fontSize: "15px",
                    fontFamily: "Poppins, sans-serif",
                    textTransform: "none",
                    py: 0.8,
                    px: 2,
                    color: isSelected ? "#006EC2" : "#363333",
                    border: isSelected ? "2px solid #006EC2" : "2px solid #091E4224",
                    backgroundColor: isSelected ? "#E3F2FD" : "transparent",
                  }}
                >
                  {opt.label}
                </Button>
              );
            })}
          </Box> */}

          {/* Date From */}
          <Box sx={{ mt: 3 }}>
            <label className="field_label">{t("filterDrawer.startDate") || "Start Date"}</label>
            <input
               ref={startRef}
    onClick={() => startRef.current?.showPicker()}
              type="date"
              value={localFilters.startDate || ""}
              onChange={(e) => setLocalFilters((prev) => ({ ...prev, startDate: e.target.value }))}
              className="project_input"
              style={{ width: "100%", height: 40 }}
            />
          </Box>

          {/* Date To */}
          <Box sx={{ mt: 3 }}>
            <label className="field_label">{t("filterDrawer.endDate") || "End Date"}</label>
            <input
               ref={endRef}
    onClick={() => endRef.current?.showPicker()}
              type="date"
              value={localFilters.endDate || ""}
              onChange={(e) => setLocalFilters((prev) => ({ ...prev, endDate: e.target.value }))}
              className="project_input"
              style={{ width: "100%", height: 40 }}
            />
          </Box>

          {/* Group by Date */}
          <Box sx={{ mt: 3 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={localFilters.group_by_date || false}
                onChange={(e) => setLocalFilters((prev) => ({ ...prev, group_by_date: e.target.checked }))}
                style={{ width: 18, height: 18, cursor: "pointer" }}
              />
              <CustomText sx={{ ...textStyles.h1, fontSize: 14, fontWeight: 400, color: "#2C384C" }}>
                {t("filterDrawer.groupByDate") || "Group by Date"}
              </CustomText>
            </label>
          </Box>

          {/* Buttons */}
          <Box sx={{ mt: 4, display: "flex", flexWrap: "wrap", gap: 2 }}>
            <CustomButton
              onClick={apply}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img src={save} alt="save" style={{ width: 16, height: 16 }} />
                  {t("filterDrawer.apply") || "Apply"}
                </Box>
              }
              size="medium"
            />
            <Button
              variant="outlined"
              onClick={clear}
              sx={{
                fontSize: 15,
                textTransform: "none",
                borderRadius: "5px",
                fontFamily: "Poppins, sans-serif",
                color: "#006EC2",
                border: "2px solid #006EC2",
                px: 3,
                py: 1,
                height: "fit-content",
              }}
            >
              {t("filterDrawer.clear") || "Clear"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default AttendanceFilterDrawer;
